import * as React from "react";
import { ParamType } from "../../api/GrammarApi";
import ParamTypeSelector, { OnParamSelectProp } from "./ParamTypeSelector";

type ParamTypeSelectorsProps = {
  paramTypes?: ParamType[];
  onSelect: OnParamSelectProp;
  getValue: (paramCode: string) => string | undefined;
};

function ParamTypeSelectors({ paramTypes, onSelect, getValue }: ParamTypeSelectorsProps) {
  if (!paramTypes || paramTypes.length === 0) {
    return null;
  }

  return (
    <>
      {paramTypes.map((paramType) => (
        <ParamTypeSelector
          key={paramType.code}
          paramType={paramType}
          onSelect={onSelect}
          value={getValue(paramType.code)}
        />
      ))}
    </>
  );
}

export default ParamTypeSelectors;
